<template>

  <div>
    <v-dialog v-model="isDisplayed"
              :persistent="true"
              max-width="700px">
      <v-card>
        <p class="dialog-title">{{ dialogTitle }}</p>
        <v-card-text>
          <v-container fluid="fluid" grid-list-xl="grid-list-xl">

            <!-- SPORT -->
            <v-flex v-if="dialogState === 'create'">
              <SportSelector :currentSportIDs="editedMatch.sportID"
                             @sportSelected="sportSelected"/>
            </v-flex>

            <!-- FEDERATION -->
            <v-flex v-if="dialogState === 'create'">
              <FederationSelector :sportID="editedMatch.sportID"
                                  :currentFederationID="editedMatch.federationID"
                                  @federationSelected="federationSelected"/>
            </v-flex>

            <!-- COMPETITION -->
            <v-flex>
              <CompetitionSelector :federationID="editedMatch.federationID"
                                   :currentCompetitionID="editedMatch.competitionID"
                                   :disabled="!editedMatch.federationID"
                                   :disabledText="'Please select a federation first'"
                                   @competitionSelected="competitionSelected"/>
            </v-flex>

            <!-- PLACE -->
            <v-flex>
              <PlaceSelector :currentPlaceID="editedMatch.placeID"
                             @placeSelected="placeSelected"/>
            </v-flex>

            <!-- CLUB 1 -->
            <v-flex>
              <NEWClubSelector :currentClubID="editedMatch.club1ID"
                               :sportID="editedMatch.sportID"
                               :disabled="!editedMatch.sportID"
                               :disabledText="'Please select a sport first'"
                               :label="'Club 1'"
                               @clubSelected="club1Selected"/>
            </v-flex>

            <!-- TEAM 1 -->
            <v-flex v-if="$country === 'US'">
              <TeamSelector :currentTeamID="editedMatch.team1ID"
                            :clubID="editedMatch.club1ID"
                            :disabled="!editedMatch.club1ID"
                            :disabledText="'Please select a club 1 first'"
                            :label="'Team 1'"
                            @teamSelected="team1Selected"/>
            </v-flex>

            <!-- CLUB 2 -->
            <v-flex>
              <NEWClubSelector :currentClubID="editedMatch.club2ID"
                               :sportID="editedMatch.sportID"
                               :disabled="!editedMatch.sportID"
                               :disabledText="'Please select a sport first'"
                               :label="'Club 2'"
                               @clubSelected="club2Selected"/>
            </v-flex>

            <!-- TEAM 2 -->
            <v-flex v-if="$country === 'US'">
              <TeamSelector :currentTeamID="editedMatch.team2ID"
                            :clubID="editedMatch.club2ID"
                            :disabled="!editedMatch.club2ID"
                            :disabledText="'Please select a club 2 first'"
                            :label="'Team 2'"
                            @teamSelected="team2Selected"/>
            </v-flex>

            <!-- DATE -->
            <v-flex class="px-2">
              <DateSelector :currentDate="editedMatch.date"
                            @dateSelected="dateSelected"/>
            </v-flex>

            <!-- REPROCESS MATCH -->
            <v-flex v-if="dialogState === 'edit' && currentEditedMatch.videoCount">
              <ToggleSwitch :value="editedMatch.reprocess"
                            :label="'Reprocess videos'"
                            @input="reprocessClicked"/>
            </v-flex>

          </v-container>

          <!-- BUTTONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="close">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="save">{{ dialogButton }}</v-btn>
          </v-card-actions>

          <!-- ERROR -->
          <v-flex>
            <v-spacer></v-spacer>
            <div class="error-message">{{ errorMessage }}</div>
          </v-flex>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import FederationSelector from '../common/FederationSelector'
import CompetitionSelector from '../common/CompetitionSelector'
import PlaceSelector from '../common/PlaceSelector'
import NEWClubSelector from '../common/NEWClubSelector'
import TeamSelector from '../common/TeamSelector'
import DateSelector from '../common/DateSelector'
import ToggleSwitch from '../ToggleSwitch'

export default {
  name: 'Dialog',
  components: {
    SportSelector,
    FederationSelector,
    CompetitionSelector,
    PlaceSelector,
    NEWClubSelector,
    TeamSelector,
    DateSelector,
    ToggleSwitch
  },
  props: [
    'dialog',
    'dialogState',
    'currentEditedMatch',
    'errorMessage'
  ],
  data () {
    return {
      isDisplayed: false,

      editedMatch: {
        sportID: '',
        federationID: '',
        competitionID: '',
        placeID: '',
        club1ID: '',
        team1ID: '',
        club2ID: '',
        team2ID: '',
        date: '',
        reprocess: false
      }
    }
  },
  mounted () {
    if (this.currentEditedMatch) {
      this.setCurrentEditedMatch()
    }
    if (this.dialog) {
      this.isDisplayed = true
    }
  },
  methods: {
    setCurrentEditedMatch () {
      console.log('setting')
      this.editedMatch = {
        sportID: this.currentEditedMatch.sportID,
        federationID: this.currentEditedMatch.federationID,
        competitionID: this.currentEditedMatch.competitionID,
        placeID: this.currentEditedMatch.placeID,
        club1ID: this.currentEditedMatch.club1ID,
        team1ID: this.currentEditedMatch.team1ID,
        club2ID: this.currentEditedMatch.club2ID,
        team2ID: this.currentEditedMatch.team2ID,
        date: this.currentEditedMatch.date,
        reprocess: false
      }

      if (this.editedMatch.club1ID === 'defaultclub000000000') {
        this.editedMatch.club1ID = ''
      }
      if (this.editedMatch.team1ID === 'defaultteam000000000') {
        this.editedMatch.team1ID = ''
      }
      if (this.editedMatch.club2ID === 'defaultclub000000000') {
        this.editedMatch.club2ID = ''
      }
      if (this.editedMatch.team2ID === 'defaultteam000000000') {
        this.editedMatch.team2ID = ''
      }
    },

    save () {
      if (!this.editedMatch.competitionID) {
        delete this.editedMatch.competitionID
      }
      if (!this.editedMatch.placeID) {
        delete this.editedMatch.placeID
      }
      if (!this.editedMatch.club1ID) {
        delete this.editedMatch.club1ID
      }
      if (!this.editedMatch.club2ID) {
        delete this.editedMatch.club2ID
      }
      if (!this.editedMatch.team1ID) {
        delete this.editedMatch.team1ID
      }
      if (!this.editedMatch.team2ID) {
        delete this.editedMatch.team2ID
      }

      if (this.dialogState === 'create') {
        delete this.editedMatch.reprocess
        this.$emit('createMatch', this.editedMatch)
      } else {
        this.$emit('editMatch', this.editedMatch)
      }
    },

    sportSelected (sportid) {
      this.editedMatch.sportID = sportid
    },
    federationSelected (federationid) {
      this.editedMatch.federationID = federationid
    },
    competitionSelected (competitionid) {
      this.editedMatch.competitionID = competitionid
    },
    placeSelected (placeid) {
      this.editedMatch.placeID = placeid
    },
    club1Selected (clubid) {
      this.editedMatch.club1ID = clubid
    },
    team1Selected (teamid) {
      this.editedMatch.team1ID = teamid
    },
    club2Selected (clubid) {
      this.editedMatch.club2ID = clubid
    },
    team2Selected (teamid) {
      this.editedMatch.team2ID = teamid
    },
    dateSelected (date) {
      this.editedMatch.date = date
    },
    reprocessClicked (value) {
      this.editedMatch.reprocess = value
    },

    close () {
      this.clearData()
      this.isDisplayed = false
    },

    clearData () {
      this.editedMatch = {
        sportID: '',
        federationID: '',
        competitionID: '',
        placeID: '',
        club1ID: '',
        team1ID: '',
        club2ID: '',
        team2ID: '',
        date: ''
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogButton + ' match'
    },

    dialogButton () {
      return this.dialogState.charAt(0).toUpperCase() + this.dialogState.slice(1)
    }
  },
  watch: {
    'dialog' () {
      if (this.isDisplayed !== this.dialog) {
        this.isDisplayed = this.dialog
      }
    },
    'isDisplayed' () {
      if (!this.isDisplayed) {
        this.clearData()
        this.$emit('dialogClosed')
      }
    },
    'currentEditedMatch' () {
      if (this.currentEditedMatch) {
        this.setCurrentEditedMatch()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .dialog-title {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-top: 20px;
  }

  .error-message {
    color: red;
    text-align: end;
    font-weight: 700;
  }

</style>



// WEBPACK FOOTER //
// src/components/matches/Dialog.vue